import { Lookup, useLookup } from '@/providers'

import { NOTIFICATION_TEMPLATES, NotificationTemplateProps } from './NotificationCard.templates'

type Props = Omit<NotificationTemplateProps, 'type'>

/**
 * Selects the component that renders this notification — `notification.type` picks the
 * template from `NOTIFICATION_TEMPLATES`. Unregistered types render nothing.
 */
export default function NotificationCard({ notification, ...rest }: Props) {
	const types = useLookup(Lookup.NotificationTypes)
	const type = types.find((t) => String(t.id) === notification.type)
	const Template = NOTIFICATION_TEMPLATES[notification.type]

	if (!Template) return null

	return <Template {...rest} notification={notification} type={type} />
}
